import { useParams } from 'react-router';

import { useQuery } from '@tanstack/react-query';

import { useIsValwin } from '~entities/group';

import { valwinAdminQueries } from './queries';

export function useIsValwinAdmin() {
  const { group = '' } = useParams();
  const isValwin = useIsValwin();

  const { data, isPending } = useQuery({
    ...valwinAdminQueries.isValwinAdmin(group),
    enabled: isValwin,
  });

  return {
    isValwinAdmin: isValwin && (data ?? false),
    isLoading: isValwin && isPending,
  };
}
